<box>
  <app-header [title]="headerTitle" [hasBottomBorder]="false" [onBack]="onBack"> </app-header>
  @if (type() === 'view') {
    <app-body>
      <subtitle-block
        [title]="'ship_interface.supply_details' | transloco"
        [hasAddNew]="true"
        [addNewTitle]="'button.add-new' | transloco"
        (addNew)="onAddNew()" />
      @if (supplies().length === 0) {
        <empty-data-block [emptyText]="'ship_interface.no_expense_items_added' | transloco"></empty-data-block>
      } @else {
        @if (supplies().length > 0) {
          <div class="px-9 py-3">
            <div class="bg-default flex flex-row items-center gap-x-[18px] overflow-hidden rounded-t-2xl px-4 py-3">
              <div class="w-2/3 truncate font-bold">{{ 'ship_interface.inventory_item' | transloco }}</div>
              <div class="w-1/3 truncate font-bold">{{ 'ship_interface.quantity' | transloco }}</div>
            </div>
            <div>
              @for (supply of supplies(); track supply) {
                <div class="flex flex-row gap-x-[18px] truncate border-b border-b-[#E2E8F0] px-4 py-3" (click)="onChooseSupply(supply)">
                  <div class="w-2/3 truncate text-[#373F4C]">{{ supply?.inventory_item_name }}</div>
                  <div class="w-1/3 truncate">{{ supply?.quantity | round: 2 }}</div>
                </div>
              }
            </div>
          </div>
        }
      }
    </app-body>
  } @else {
    <app-body>
      <div class="flex w-full flex-row gap-2 px-9 py-3">
        <dropdown
          [label]="'ship_interface.inventory_item' | transloco"
          [required]="true"
          [placeholder]="'ship_interface.select_item' | transloco"
          class="w-full"
          [options]="inventories"
          displayName="title"
          selectType="value"
          [control]="form.get('inventory_item_id')">
        </dropdown>
        <textbox
          [label]="'ship_interface.quantity' | transloco"
          [required]="true"
          [placeholder]="'0.00'"
          type="number"
          class="w-full"
          [isDecimal]="true"
          [decimal]="2"
          [control]="form.get('quantity')"></textbox>
      </div>
    </app-body>
  }
  <app-footer [onDiscard]="type() === 'edit' ? onDiscard : null" [onDelete]="type() === 'edit' ? onDelete : null" [onSave]="onSave"></app-footer>
</box>
